export default __webpack_public_path__ + "static/media/celebrate.b31b9225519476948bb262716fd5b2a0.svg";